/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './RetrieveUsernameSuccess.style';

import LazyLoginMain from 'src/shared/app/authentication/component/support/login/LazyLoginSupportMain';
import messages from 'src/shared/app/authentication/l10n/retrieveUsernameL10n';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { loginRoute } from 'src/shared/app/base/route/setting/routeSettings';
import PrimaryButton from 'src/shared/ui/component/button/PrimaryButton';
import SecondaryButton from 'src/shared/ui/component/button/SecondaryButton';
import InstructionText from 'src/shared/ui/component/text/InstructionText';

type Props = {
  eventName: string,
  username: string,
  handleSendLoginLink: () => void,
};

const useStyles = createUseStyles(styles);

const RetrieveUsernameSuccessSectionDumb = ({
  eventName,
  username,
  handleSendLoginLink,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [loginPath] = useRoutes(loginRoute);

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onSuccessMouseOver = () => LazyLoginMain.preload();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <InstructionText>
        {intl.formatMessage(messages.success, { eventName })}
      </InstructionText>
      <p className={classes.username}>{username}</p>
      <InstructionText>
        {intl.formatMessage(messages.successLoginHelper)}
      </InstructionText>
      <div className={classes.action}>
        <PrimaryButton
          large
          href={loginPath}
          handleMouseOver={onSuccessMouseOver}
        >
          {intl.formatMessage(messages.successLoginCta)}
        </PrimaryButton>
      </div>
      <InstructionText>
        {intl.formatMessage(messages.successSendLinkHelper)}
      </InstructionText>
      <div className={classes.action}>
        <SecondaryButton large handleClick={handleSendLoginLink}>
          {intl.formatMessage(messages.successSendLinkCta)}
        </SecondaryButton>
      </div>
    </div>
  );
};

export default compose(React.memo)(RetrieveUsernameSuccessSectionDumb);
